<template>
  <div>
    <div v-if="coachList.length" class="coach-page">
      <div v-for="(item, index) in coachList" :key="index" class="item">
        <img :src="imageSrc(item.img)" class="coach-img" alt="coach-img">
        <ul :class="{first : index === 0}">
          <li>
            <p class="name">{{item.koNm}}</p>
            <p class="sub">{{item.engNm}}</p>
          </li>
          <li>
            <p>{{item.position}}</p>
            <p>{{item.birthday}}</p>
            <p v-html="htmlConverter(item.education)" style="white-space: pre-line;"></p>
          </li>
        </ul>
      </div>
    </div>
    <div v-else class="empty-div">
      데이터가 없습니다.
    </div>
  </div>
</template>

<script>
import coach from '@/components/Player/Json/coach'
import {htmlConverter} from '@/lib';
export default {
  name: 'Coach',
  data() {
    return {
      coachList: [],
    }
  },
  mounted () {
    this.getCoachList();
  },
  methods: {
    htmlConverter,
    getCoachList() {
      this.coachList = coach;
    },
    imageSrc(imgSrc) {
      return require('@/assets/img/player/coach/'+imgSrc+'.png');
    },
  }
}
</script>
<style scoped>
</style>
